module.exports = __webpack_public_path__ + "static/img/13.670fd7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-th/13.jpg
// module id = H37F
// module chunks = 1